import theme from '@adsk/alloy-react-theme';

export const BADGE_VARIANTS = {
  SOLID: 'solid',
  OUTLINE: 'outline',
  LINE: 'line',
} as const;

export const BADGE_SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
} as const;

export const BADGE_COLORS = {
  DEFAULT: theme.colors.charcoal700,
  BLUE: theme.colors.adskBlue500,
  GREEN: theme.colors.green500,
  RED: theme.colors.red500,
  PURPLE: theme.colors.purple500,
  YELLOW: theme.colors.yellowOrange500,
  GRAY: theme.colors.charcoal900,
  GRAY_200: theme.colors.charcoal200,
} as const;
